import { EnvironmentConfiguration } from '@absg/angular-common';
import { AuthenticationService } from '@absg/angular-platform';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationResult } from '@azure/msal-browser';
import { Observable, of } from 'rxjs';
import { concatMap, debounceTime, filter, first, tap } from 'rxjs/operators';

interface AuthStartVm {
}

@Component({
  selector: '[nc-auth-start]',
  template: 'Checking Auth... @if (vm$|async) {<div></div>}',
  standalone: false,
})
export class AuthStartComponent implements OnInit {
  vm$: Observable<AuthStartVm>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private environment: EnvironmentConfiguration,
    private authService: AuthenticationService,
  ) {

  }

  ngOnInit(): void {
    this.vm$ = this.activatedRoute.fragment.pipe(
      first(),
      debounceTime(500),
      concatMap(params => {
        const request = {} as AuthenticationResult;
        // console.log(`fragment: ${params}`);
        request.code = params;
        if (!params) {
          this.router.navigate(['/home']);
          return of(null);
        }
        // console.log(`url: ${this.router.url}`);
        // console.log(`url2: ${this.activatedRoute.url}`);

        this.removeAnyExistingKeys();
        this.transferMsalKeys();
        this.transferMsalKeys();

        // const key = 'msal.interaction.status';
        // set this to the scope

        // sessionStorage.setItem(key, this.environment.apiConfig.scopes[0]);
        // take the state, decode it, then build token objects

        // if this doesn't work, try copying the session values over?
        //  cache.loadExternalTokens(params.state)

        return this.authService.handleRedirectObservable(`#${params}`).pipe(
          concatMap(value => {
            if (!value) {
              //  console.log(`logged in: ${value}`);
            }
            return this.authService.isLoggedIn$.pipe(
              //  tap(x => console.log(`is logged in is ${x}`)),
              filter(x => !!x),
            );
          }),
          tap(() => {
            //  console.log('about to nav to dispense as we are logged in');
            this.authService.setIsUserLoggedInToStation(true); // double check if this is the best place/way to approach
            this.router.navigate(['/auth']);
          }),
        );
      }));
  }

  private removeAnyExistingKeys(): void {
    // if you don't do this it can keep the previous other user's info and use that
    // which is not cool if you log in as User A, log out, log in as User B, and then still have A's token
    const authorities = Object.keys(this.environment.b2cPolicies.authorities);
    const authKeys = new Array<string>();
    authorities.forEach(auth => {
      const url = this.environment.b2cPolicies.authorities[auth].authority as string;
      const last = url.lastIndexOf('/', url.length - 1);
      const authority = url.substring(last + 1);
      authKeys.push(authority.toLowerCase());
    });

    const keys = Object.keys(sessionStorage);
    keys.forEach(key => {
      if (key.startsWith('msal.')) {
        sessionStorage.removeItem(key);
      } else {
        authKeys.forEach(envKey => {
          if (key.toLowerCase().indexOf(envKey) > -1) {
            sessionStorage.removeItem(key);
          }
        });
      }
    });
  }

  private transferMsalKeys(): void {
    // msal isn't using local storage as configured
    // jwt-return.js copies values from other electron window session to local
    // here we copy the msal values back from local to session to be able to capture the jwt response
    const keys = Object.keys(localStorage);
    // console.log(keys);
    // let i = 0;
    keys.forEach(key => {
      if (key.startsWith('msal.')) {
        // console.log(`copying key ${key}`);
        //  i++;
        sessionStorage.setItem(key, localStorage.getItem(key));
        localStorage.removeItem(key);
      } else {
        // console.log(`ignoring ${key}`); // keep for debugging if needed later
      }
    });
    // console.log(`copied ${i} keys over`);
  }
}
